const ArrowPrevious = () => (
    <svg width="12" height="20" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.75 10L1.25 5.5L5.75 1" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
)

export default ArrowPrevious